import React from 'react'
import { MegaMenuWithHover } from './menu'

interface HeaderProps {
  hasCareerSite?: boolean
}

export const Header: React.FC<HeaderProps> = ({ hasCareerSite = false }) => (
  <header>{!hasCareerSite && <MegaMenuWithHover />}</header>
)
